module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_CHARCUTIER.ff290ee8.webp";